module Meevo.Plugins.DashboardGoals {

    import GoalInputTypeEnum = Meevo.Components.Goals.GoalInputTypeEnum;
    import ISelectItem = Meevo.Model.ISelectItem;
    import IDiscreteBarChartOptions = Meevo.Plugins.Controls.IDiscreteBarChartOptions;

    class MeevoDashboardGoalsGraphsViewComponent implements angular.IComponentController {

        static $inject = [
            '$scope',
            '$translate',
            '$locale',
            'meevo.plugins.docsAndForms.DashboardGoalsGraphsLogic'
        ];

        public goalsModel: IDashboardGoalModel;
        public measurement: GoalInputTypeEnum;

        public averageTicketGoalsData: IBarChartItem[] = [];
        public salesGoalsData: IBarChartItem[] = [];
        public rebookPercentGoalsData: ICircleBarChartItem[] = [];
        public frequencyOfVisitGoalsData: IBarChartItem[] = [];
        public newClientGoalsData: IBarChartItem[];
        public fiveStarRatingGoalsData: IBarChartItem[];
        public requestRateGoalsData: ICircleBarChartItem[];
        public retentionGoalsData: IBarChartItem[];
        public membershipGoalsData: IBarChartItem[];
        public productivityGoalsData: any[];

        public productivityDateRangeList: DateRangeList = [];
        public averageTicketDateRangeList: DateRangeList = [];
        public salesDateRangeList: DateRangeList = [];
        public rebookDateRangeList: DateRangeList = [];
        public frequencyOfVisitDateRangeList: DateRangeList = [];
        public newClientDateRangeList: DateRangeList = [];
        public fiveStarRatingDateRangeList: DateRangeList = [];
        public membershipDateRangeList: DateRangeList = [];
        public requestRateDateRangeList: DateRangeList = [];

        public averageTicketDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public salesDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public rebookDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public frequencyOfVisitDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public newClientDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public fiveStarRatingDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public requestRateDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public retentionDateRange: GoalDateRangeEnum = GoalDateRangeEnum.SpecificYear;
        public membershipDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;
        public productivityDateRange: GoalDateRangeEnum = GoalDateRangeEnum.YearToDate;

        public measurementSelect: ISelectItem<GoalInputTypeEnum>[];
        public currencySymbol = this.$locale.NUMBER_FORMATS.CURRENCY_SYM;

        public productivityChartOptions: IDiscreteBarChartOptions = {};

        constructor(
            private $scope: ng.IScope,
            private $translate: ng.translate.ITranslateService,
            private $locale: angular.ILocaleService,
            private dashboardGoalsGraphsLogic: IDashboardGoalsGraphsLogic
        ) {
            Object.keys(GOAL_CATEGORY_LABELS).forEach((key) => {
                GOAL_CATEGORY_LABELS[key] = $translate.instant(GOAL_CATEGORY_LABELS[key]);
            });

            this.measurementSelect = [
                {
                    value: GoalInputTypeEnum.Currency,
                    label: this.$translate.instant('LABEL_CURRENCY_AMOUNT', {currencySymbol: this.currencySymbol})
                },
                {value: GoalInputTypeEnum.Numeric, label: 'LABEL_UNITS'},
            ];
        }

        private prepareFilters() {

            this.productivityDateRangeList = this.dashboardGoalsGraphsLogic.prepareFilter(this.goalsModel.productivity);
            this.averageTicketDateRangeList = this.dashboardGoalsGraphsLogic.prepareFilter(this.goalsModel.averageTicket);
            this.salesDateRangeList = this.dashboardGoalsGraphsLogic.prepareFilter(this.goalsModel.sales);
            this.rebookDateRangeList = this.dashboardGoalsGraphsLogic.prepareFilter(this.goalsModel.rebook);
            this.frequencyOfVisitDateRangeList = this.dashboardGoalsGraphsLogic.prepareFilter(this.goalsModel.frequencyOfVisit);
            this.newClientDateRangeList = this.dashboardGoalsGraphsLogic.prepareFilter(this.goalsModel.newClient);
            this.fiveStarRatingDateRangeList = this.dashboardGoalsGraphsLogic.prepareFilter(this.goalsModel.fiveStarRating);
            this.membershipDateRangeList = this.dashboardGoalsGraphsLogic.prepareFilter(this.goalsModel.membership);
            this.requestRateDateRangeList = this.dashboardGoalsGraphsLogic.prepareFilter(this.goalsModel.requestRate);
        }

        $onInit() {
            this.$scope.$watch(() => this.goalsModel, (value) => {
                if (!value) return;

                this.prepareFilters();
                this.prepareGraphs();
            });
        }

        public prepareGraphs() {
            this.membershipGoalsData = this.dashboardGoalsGraphsLogic.barChartMapFn(this.goalsModel.membership, this.membershipDateRange, this.$translate, GoalInputTypeEnum.Numeric);

            this.averageTicketGoalsData = this.dashboardGoalsGraphsLogic.barChartMapFn(this.goalsModel.averageTicket, this.averageTicketDateRange, this.$translate);

            this.salesGoalsData = this.dashboardGoalsGraphsLogic.barChartMapFn(this.goalsModel.sales, this.salesDateRange, this.$translate, this.measurement);

            const requiredRebook = this.goalsModel.rebook && this.goalsModel.rebook.filter((row) => row.dateRangeEnum === this.rebookDateRange)[0];
            if (requiredRebook) {
                this.rebookPercentGoalsData = [
                    {key: this.$translate.instant('LABEL_REBOOKING_PERCENT'), y: requiredRebook.rebooked},
                    {
                        key: this.$translate.instant('LABEL_NUMBER_OF_CLIENTS_WERE_NOT_REBOOKED'),
                        y: (requiredRebook.total - requiredRebook.rebooked)
                    }
                ];
            } else {
                this.rebookPercentGoalsData = [];
            }

            this.frequencyOfVisitGoalsData = this.dashboardGoalsGraphsLogic.barChartMapFn(this.goalsModel.frequencyOfVisit, this.frequencyOfVisitDateRange, this.$translate);

            this.newClientGoalsData = this.dashboardGoalsGraphsLogic.barChartMapFn(this.goalsModel.newClient, this.newClientDateRange, this.$translate, GoalInputTypeEnum.Numeric);
            this.fiveStarRatingGoalsData = this.dashboardGoalsGraphsLogic.barChartMapFn(this.goalsModel.fiveStarRating, this.fiveStarRatingDateRange, this.$translate, GoalInputTypeEnum.Currency);

            this.requestRateGoalsData = [
                {key: this.$translate.instant('% requested'), y: this.goalsModel.requestRate[0].actualPercent || 0},
                {
                    key: this.$translate.instant('% not requested'),
                    y: (1 - (this.goalsModel.requestRate[0].actualPercent || 0))
                }
            ];
            this.retentionGoalsData = this.dashboardGoalsGraphsLogic.barChartMapFn(this.goalsModel.retention, this.retentionDateRange, this.$translate, GoalInputTypeEnum.Percentage);
            this.productivityGoalsData = this.dashboardGoalsGraphsLogic.barChartMapFn(this.goalsModel.productivity, this.productivityDateRange, this.$translate, GoalInputTypeEnum.Percentage, true);

            this.prepareGraphOptions();
        }

        public prepareGraphOptions() {
            let productivityIsMonthly = this.productivityDateRange === GoalDateRangeEnum.YearToDate || this.productivityDateRange === GoalDateRangeEnum.LastTwelveMonths;
            this.productivityChartOptions = {rotateLabels: productivityIsMonthly ? -45 : null};
        }

        public changeMeasurement(): void {
            if (!this.goalsModel) {
                return;
            }

            this.salesGoalsData = this.dashboardGoalsGraphsLogic.barChartMapFn(
                this.goalsModel.sales,
                this.salesDateRange,
                this.$translate,
                this.measurement
            );
        }
    }


    angular.module('meevo.plugins.dashboardGoals')
        .component('meevoDashboardGoalsGraphsViewComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/dashboardGoals/components/graphsView/graphsView.component.html',
            controller: MeevoDashboardGoalsGraphsViewComponent,
            controllerAs: '$ctrl',
            bindings: {
                goalsModel: '<'
            }
        });

}
